import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Reveal from "./Reveal";
import { CTA_IMG } from "./data";
import { useT } from "./i18n";

export default function FinalCTA() {
  const { t } = useT();
  return (
    <section id="join" className="scroll-mt-24 relative overflow-hidden">
      <img src={CTA_IMG} alt="Horses at rest in a misty field at first light" loading="lazy" decoding="async" className="absolute inset-0 h-full w-full object-cover" />
      <div className="absolute inset-0 bg-[#173A2C]/80" />
      <div className="grain absolute inset-0 opacity-15" />
      <div className="relative mx-auto max-w-4xl px-5 py-24 text-center">
        <Reveal>
          <h2 className="font-serif text-4xl font-light leading-tight text-white sm:text-5xl lg:text-6xl">{t.cta.heading}</h2>
          <p className="mx-auto mt-4 max-w-xl text-base text-white/80">{t.cta.sub}</p>
          <div className="mt-8 flex flex-col justify-center gap-3 sm:flex-row">
            <Link to="/register" data-testid="final-candidate-btn" className="inline-flex items-center justify-center gap-2 rounded-full bg-[#C4A46B] px-7 py-3.5 text-sm font-semibold text-[#173A2C] transition-transform hover:-translate-y-0.5">
              {t.cta.candidate} <ArrowRight className="h-4 w-4" />
            </Link>
            <Link to="/register" data-testid="final-employer-btn" className="inline-flex items-center justify-center gap-2 rounded-full border border-white/40 px-7 py-3.5 text-sm font-semibold text-white transition-colors hover:bg-white/10">
              {t.cta.employer}
            </Link>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
